import React from 'react';
import { Row, Col } from 'antd';
import { Informations } from './Informations';
import { useRosaResultContext } from '../context';

export function ReportInformation() {
	const { rosaResult } = useRosaResultContext();

	const { informations } = rosaResult;

	const reportData = {
		organization_name: informations.organization_name,
		company_name: informations.company_name,
		sector_name: informations.sector_name,
		workstation_name: informations.workstation_name,
		line_name: informations.line_name,
		activity_name: informations.activity_name,
		report_name: informations.report_name,
		file_name: informations.original_name,
		collection_date: informations.collection_date,
		assessment_date: informations.assessment_date,
		evaluator_name: informations.evaluator_name
	};

	return (
		<Row>
			<Col span={24}>
				<Informations data={reportData} />
			</Col>
		</Row>
	);
}
